import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_shell/upload-data")({
  beforeLoad: () => {
    throw redirect({ to: "/behaviour-studio", replace: true });
  },
});
